import {Component, OnDestroy, OnInit} from '@angular/core';
import {BarrierefreiheitService} from '../../services/barrierefreiheit.service';

@Component({
  selector: 'barrierefreiheitIcon',
  templateUrl: './barrierefreiheitIcon.component.html',
  styleUrls: ['./barrierefreiheitIcon.component.css'],
})

export class BarrierefreiheitIconComponent implements OnInit, OnDestroy {

  public unterschiede
  public subscription
  constructor(
    private barrierefreiheitService: BarrierefreiheitService,
  ) { }

  ngOnInit() {
    this.barrierefreiheitService.barriereEinstellungenInit()
    this.subscription = this.barrierefreiheitService.unterschiede.subscribe(aktuellerWert => {
      this.unterschiede = aktuellerWert
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  public einstellungenOeffnen(){
    this.barrierefreiheitService.barriereDialog()
  }
}
